<template>
  <div
    id="DragDropFileUploadComponent"
    class="mt-2"
    @dragover.prevent="dragOver"
    @dragleave.prevent="dragLeave"
    @drop.prevent
  >
    <v-hover>
      <template v-slot:default="{ hover }">
        <v-img
          class="dragDropBorder"
          :class="getClasses"
          height="245"
          contain
          hover
          placeholder="img/flo_placeholder.png"
          :src="getSrc"
          @drop="handleFileDrop"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <div
                class="preview-text"
                align="center"
                justify="center"
              >
                <v-icon large>
                  mdi-cloud-upload-outline
                </v-icon>
                <div>
                  <h3>Drag & Drop</h3>
                  <p>your logo image here</p>
                </div>
              </div>
            </v-row>
          </template>
          <v-fade-transition>
            <v-overlay
              v-if="hover"
              :absolute="true"
              :value="true"
            >
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <div
                  class="preview-text"
                  align="center"
                  justify="center"
                >
                  <v-icon large>
                    mdi-cloud-upload-outline
                  </v-icon>
                  <div>
                    <h3 class="white--text">
                      Drag & Drop
                    </h3>
                    <p>your logo image here</p>
                  </div>
                </div>
              </v-row>
            </v-overlay>
          </v-fade-transition>
        </v-img>
      </template>
    </v-hover>
    <input
      ref="file"
      type="file"
      accept="image/jpeg, image/png"
      hidden
      @change="handleFileInput"
    >
    <v-btn
      color="primary"
      width="100%"
      :loading="loading"
      @click="$refs.file.click()"
    >
      Click to choose an image (jpg / png)
    </v-btn>
    <v-alert
      v-model="showErrors"
      dense
      outlined
      tile
      type="error"
      dismissible
    >
      {{ errors.message }}
    </v-alert>
  </div>
</template>
<script>
export default {
  name: 'DragDropFileUploadComponent',
  props: {
    loading: Boolean,
    settings: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showErrors: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => {
        return {
          errors: {}
        }
      }
    }
  },
  data: () => ({
    isDragging: false,
    files: []
  }),
  computed: {
    getClasses () {
      return { isDragging: this.isDragging }
    },
    getSrc () {
      if (this.files[0] != null) {
        // Displays the "Selected" image
        return URL.createObjectURL(this.files[0])
      } else if (this.settings && this.settings.logo != null) {
        // If the image exists and there is not a "Selected" image
        return '/agency-file/logo'
      } else {
        return undefined
      }
    }
  },
  created () {
    //
  },
  methods: {
    handleFileDrop (e) {
      this.files = []
      const droppedFiles = e.dataTransfer.files
      if (!droppedFiles) return
      this.files.push(droppedFiles[0])
      this.isDragging = false
      this.$emit('imageSelected', this.files[0])
    },
    handleFileInput (e) {
      this.files = []
      const files = e.target.files
      if (!files) return
      this.files.push(files[0])
      this.$emit('imageSelected', this.files[0])
    },
    dragOver () {
      this.isDragging = true
    },
    dragLeave () {
      this.isDragging = false
    }
  }
}
</script>
<style lang='scss'>
#DragDropFileUploadComponent {
  .dragDropBorder {
    border: 2px dashed #999;
  }
  .isDragging {
    background-color: #999 !important;
    border: 2px solid red !important;
  }
}
</style>
